// extracted by mini-css-extract-plugin
module.exports = {"container":"AddAffiliationPage_container__Yh0dz"};